import { render, staticRenderFns } from "./editorTopMenu.vue?vue&type=template&id=2b962e6e&scoped=true"
import script from "./editorTopMenu.vue?vue&type=script&lang=js"
export * from "./editorTopMenu.vue?vue&type=script&lang=js"
import style0 from "./editorTopMenu.vue?vue&type=style&index=0&id=2b962e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b962e6e",
  null
  
)

export default component.exports